import React from 'react'
import './looks-like-you-are-done-popup.css'

const LooksLikeYouAreDonePopup = ({saveAndCloseTask, deleteAndCloseTask}) => {
    return(
        <div className='looks-like-you-are-done__wrapper'>
            <div className='looks-like-you-are-done'>
                <div className='looks-like-you-are-done__question-mark-icon'>?</div>
                <div className='looks-like-you-are-done__title'>Workflow Complete?</div>
                <div className='looks-like-you-are-done__subtitle'>It looks like this workflow is complete. Would you like to mark it as completed and delete it?</div>
                <div className='looks-like-you-are-done__btn-wrapper'>
                    <div className='looks-like-you-are-done__btn__no' onClick={() => saveAndCloseTask()}>Not Yet</div>
                    <div className='looks-like-you-are-done__btn__yes' onClick={() => deleteAndCloseTask()}>Complete</div>
                </div>
            </div>
        </div>
    )
}
export default LooksLikeYouAreDonePopup;